/**
 * Filtros da listagem de clientes na query string — preservados ao abrir/voltar do detalhe.
 */
export function useClientesListQuery() {
  const filtersToQuery = (filters) => {
    const q = {}
    if (filters.nome?.trim()) q.nome = filters.nome.trim()
    if (filters.cpfCnpj?.trim()) q.cpfCnpj = filters.cpfCnpj.trim()
    if (filters.email?.trim()) q.email = filters.email.trim()
    if (filters.whatsapp?.trim()) q.whatsapp = filters.whatsapp.trim()
    if (filters.tag) q.tag = String(filters.tag)
    if (filters.usuario) q.usuario = String(filters.usuario)
    if (filters.page && Number(filters.page) > 1) q.page = String(filters.page)
    return q
  }

  const queryToFilters = (query) => ({
    nome: query.nome != null ? String(query.nome) : '',
    cpfCnpj: query.cpfCnpj != null ? String(query.cpfCnpj) : (query.cpf != null ? String(query.cpf) : ''),
    email: query.email != null ? String(query.email) : '',
    whatsapp: query.whatsapp != null ? String(query.whatsapp) : '',
    tag: query.tag != null ? String(query.tag) : '',
    usuario: query.usuario != null ? String(query.usuario) : '',
    page: query.page != null ? Math.max(1, parseInt(String(query.page), 10) || 1) : 1
  })

  return { filtersToQuery, queryToFilters }
}
